import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	reorderErrorTitle: {
		id: 'native-issue-table.services.rank-mutation.reorder-error-title',
		defaultMessage: "We couldn't reorder those issues",
		description: 'Heading text for error flag that appears when reordering fails',
	},
	reorderErrorDescription: {
		id: 'native-issue-table.services.rank-mutation.reorder-error-description',
		defaultMessage: 'Wait a few moments, then give it another try.',
		description: 'Body text for error flag that appears when reordering fails',
	},
	reorderErrorTitleIssueTermRefresh: {
		id: 'native-issue-table.services.rank-mutation.reorder-error-title-issue-term-refresh',
		defaultMessage: "We couldn't reorder those work items",
		description: 'Heading text for error flag that appears when reordering fails',
	},
	reorderIssue400ErrorDescription: {
		id: 'native-issue-table.services.rank-mutation.reorder-issue-400-error-description',
		defaultMessage: 'You don’t have permission to reorder this issue. Contact a project admin.',
		description:
			'Flag description. Informs a user that they don’t have permission to reorder this issue.',
	},
	reorderIssue404ErrorDescription: {
		id: 'native-issue-table.services.rank-mutation.reorder-issue-404-error-description',
		defaultMessage: 'We’re having trouble reordering this issue. To continue, refresh the page.',
		description:
			'Flag description. Informs a user that there was an issue reordering those work items.',
	},
	reorderIssue409ErrorDescription: {
		id: 'native-issue-table.services.rank-mutation.reorder-issue-409-error-description',
		defaultMessage: 'There was a conflict reordering those issues. Please try again.',
		description:
			'Flag description. Informs a user that there was an issue reordering those work items.',
	},
	reorderIssue400ErrorDescriptionIssueTermRefresh: {
		id: 'native-issue-table.services.rank-mutation.reorder-issue-400-error-description-issue-term-refresh',
		defaultMessage: 'You don’t have permission to reorder this work item. Contact a project admin.',
		description:
			'Flag description. Informs a user that they don’t have permission to edit this issue.',
	},
	reorderIssue404ErrorDescriptionIssueTermRefresh: {
		id: 'native-issue-table.services.rank-mutation.reorder-issue-404-error-description-issue-term-refresh',
		defaultMessage:
			'We’re having trouble reordering this work item. To continue, refresh the page.',
		description:
			'Flag description. Informs a user that there was an issue reordering those work items.',
	},
	reorderIssue409ErrorDescriptionIssueTermRefresh: {
		id: 'native-issue-table.services.rank-mutation.reorder-issue-409-error-description-issue-term-refresh',
		defaultMessage: 'There was a conflict reordering those work items. Please try again.',
		description:
			'Flag description. Informs a user that there was a conflict in ranking value when reordering those work items.',
	},
});
